import type { NextPage, GetStaticProps } from 'next';

import PageService from 'services/PageService/PageService';

import PageLayout from 'blocks/Layouts/page-layout';
import Press from 'blocks/press';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';

import StaticPageContent from 'data/staticPageContent';
import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';

import pressImage from 'assets/press/header-image.webp';

import type { StaticPageContentProps } from 'data/staticPageContent';
import type { IGenericPage, IPressHighlightsPage } from 'types/interfaces';

interface IPressHighlightsPageInterface
  extends IPressHighlightsPage,
    IGenericPage {
  pageContent: StaticPageContentProps;
}

const PressPage: NextPage<IPressHighlightsPageInterface> = ({
  globalLayoutProps,
  pressList,
  pageContent,
}) => {
  return (
    <GlobalLayout {...globalLayoutProps}>
      <PageLayout {...pageContent} image={pressImage}>
        <Press pressList={pressList} />
      </PageLayout>
    </GlobalLayout>
  );
};

export default PressPage;

export const getStaticProps: GetStaticProps = async () => {
  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.PRESS,
  });
  const pressPageProps = await PageService.getPressPageProps();
  const pageContent = StaticPageContent[navigationPaths.PRESS];

  return {
    props: {
      ...genericPageProps,
      ...pressPageProps,
      pageContent,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
